import type { AnalyticsOverviewResponse } from "@/@types/Analytics";
import CardCurrency from "@/components/shared/CardCurrency/CardCurrency";
import { useTranslation } from "react-i18next";

interface OverviewCardsProps {
  overview?: AnalyticsOverviewResponse;
  isLoading: boolean;
}

export function OverviewCards({ overview, isLoading }: OverviewCardsProps) {
  const { t } = useTranslation("reports");

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <CardCurrency
        text={t("reports:gross_total")}
        value={overview?.gross_revenue || "R$ 0,00"}
        total={overview?.approved_sales_count}
        hasTotal
        status="paid"
        isLoading={isLoading}
      />
      <CardCurrency
        text={t("reports:net_revenue")}
        value={overview?.net_revenue || "R$ 0,00"}
        status="paid"
        isLoading={isLoading}
      />
      <CardCurrency
        text={`${t("reports:average_order_value")} (AOV)`}
        value={overview?.average_order_value || "R$ 0,00"}
        status="pending"
        isLoading={isLoading}
      />
      <CardCurrency
        text={t("reports:checkout_conversion_rate")}
        value={overview?.checkout_conversion_rate || "0%"}
        status="paid"
        isLoading={isLoading}
      />
    </div>
  );
}
